module.exports = __webpack_public_path__ + "img/cj_1@2x.86dfc663.png";